import styled from 'styled-components';
import { styleguide, colors } from "../../../../../styleguide";
import { IconExternalFill } from "../../../../Icon";
export var StyledIconExternalFill = styled(IconExternalFill).withConfig({
  displayName: "CategoriesLabelstyles__StyledIconExternalFill",
  componentId: "sc-1451jxj-0"
})(["margin:0 3px;vertical-align:text-top;"]);
export var Parenthesis = styled.span.withConfig({
  displayName: "CategoriesLabelstyles__Parenthesis",
  componentId: "sc-1451jxj-1"
})(["font-family:", ";font-size:11px;color:", ";display:block;margin-top:-10px;"], styleguide.font.family.regular, colors.grey700);
//# sourceMappingURL=CategoriesLabel.styles.js.map